<template>
  <div class="header">
    <!-- 顶部导航栏 -->
    <div class="top-bar">
      <div class="container">
        <div class="top-left">
          <img src="@/assets/images/1.png" alt="" class="top-left-icon">
          <div class="top-left-text">
            <span>欢迎来到搏亿购！</span>
            <router-link v-if="!isLoggedIn" to="/login" class="top-left-text-text">请登录</router-link>
            <span v-else style="color: #333;">{{ userInfo.nickname }}</span>
            <router-link v-if="!isLoggedIn" to="/register">免费注册</router-link>
            <span v-else @click="handleLogout" style="cursor: pointer;margin-left: 10px;">退出登录</span>
          </div>
        </div>
        <div class="top-nav">
          <router-link to="/buyer" class="nav-link">买家中心</router-link>
          <span class="nav-divider">|</span>
          <router-link to="/seller" class="nav-link">卖家中心</router-link>
        </div>
      </div>
    </div>

    <!-- 主头部 -->
    <div class="main-header">
      <div class="container">
        <!-- Logo和搜索框 -->
        <div class="header-top">
          <div class="logo">
            <router-link to="/">
              <img src="../assets/logo.png" alt="博亿购" />
            </router-link>
            <!-- <span>博亿购</span> -->
          </div>

          <div class="search-container">
            <div class="search-box">
              <input type="text" placeholder="请输入关键词" v-model="keyword" />
              <button class="search-btn" @click="handleSearch">搜索</button>
              <button class="quick-search">免费开店卖货</button>
            </div>

            <!-- 搜索分类 -->
            <div class="search-categories">
              <el-tabs v-model="activeFenleiName" @tab-click="handleFenleiClick" style="width: 700px;">
                <el-tab-pane :label="item.name" :name="item.aid" v-for="(item, index) in topList"
                  :key="index"></el-tab-pane>
              </el-tabs>

            </div>
          </div>

          <!-- 二维码 -->
          <div class="qr-code">
            <div>
              <img src="@/assets/images/laod.png" alt="安卓" @click="qrCodeDialogVisible = true" />
            </div>
            <p>下载搏亿购App </p>
            <p>手机询价，沟通更方便</p>
          </div>
        </div>

        <!-- 主导航菜单 -->
        <div class="main-nav" v-if="home">
          <el-tabs v-model="localActiveName" @tab-click="handleClick" style="">
            <el-tab-pane :label="item.label" :name="item.value" v-for="(item, index) in tabsList"
              :key="index"></el-tab-pane>
          </el-tabs>

          <div>
            <span>选择城市：</span>
            <el-cascader v-model="selectedValue" :clearable="true" :options="options" :show-all-levels="false"
              @change="handleChange"></el-cascader>
          </div>
        </div>


      </div>
    </div>
    <el-dialog :visible="qrCodeDialogVisible" @close="qrCodeDialogVisible = false" title="扫码下载搏亿购App" width="30%"
      center>
      <div style="text-align: center; display: flex; align-items: center; justify-content: space-around;">
        <div>
          <img src="@/assets/images/laod.png" alt="安卓扫码" style="width: 358px; height: 208px;" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'Header',
  data() {
    return {
      qrCodeDialogVisible: false,
      // activeName: '1',
      localActiveName: this.activeName,
      tabsList: [
        {
          label: '首页',
          value: '1'
        },
        {
          label: '供应大厅',
          value: '2'
        },
        {
          label: '采购大厅',
          value: '3'
        },
        {
          label: '看行情',
          value: '4'
        },
        {
          label: '附近货源',
          value: '5'
        },
        {
          label: '找产地',
          value: '6'
        },
        {
          label: '搏亿学堂',
          value: '7'
        },
        {
          label: '商家推广',
          value: '8'
        }
      ],
      activeFenleiName: '',
      topList: [],
      centerList: [],
      options: [],
      selectedValue: [],

      keyword: ''
    };
  },
  created() {
    this.getHomeTabs();
    this.getAreaList();
  },
  mounted() {
    if (this.$store.state.cityCode !== '') {
      this.selectedValue = this.$store.state.cityCode ? this.$store.state.cityCode : []
    }
  },
  props: {
    activeName: {
      type: String,
      default: '1'
    },
    home: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  watch: {
    activeName(newVal, oldVal) {
      this.localActiveName = newVal;
    }
  },
  methods: {
    handleLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
    handleClick(tab, event) {
      // 使用本地属性发出事件
      this.$emit('tab-click', String(this.localActiveName));
    },

    handleFenleiClick(tab, event) {
      // console.log(tab, event);
      console.log(this.activeFenleiName, 'activeFenleiName');
      this.$emit('tab-fenlie-click', String(this.activeFenleiName));

    },

    // 搜索跳转
    handleSearch() {
      this.$emit('keyword', String(this.keyword))
      this.localActiveName = '2'
      this.handleClick()
    },

    // 获取顶部分类数据
    getHomeTabs() {
      this.$api.getHomeTabs().then(res => {
        // console.log(res, 'res');
        let list = res;
        this.topList = list;
        this.activeFenleiName = list[0].aid
        this.$emit('tab-fenlie-click', String(this.activeFenleiName));
        console.log(this.activeFenleiName, 'activeFenleiName');
        // this.topList.unshift({
        //   aid: '0',
        //   name: "全部"
        // });
      }).catch(err => {
        this.$message.error(err);

      })
    },

    // 获取省市区列表，并只保留两级
    getAreaList() {
      this.$api.getAreaList().then(res => {
        // console.log(res, 'res');
        let list = res;

        // 处理数据，只保留省和市两级，去除区的数据
        const processedList = list.map(province => {
          // 复制省份对象，避免直接修改原数据
          const newProvince = { ...province };

          // 如果有城市级数据，只保留城市级，去除城市下的区数据
          if (newProvince.children && newProvince.children.length) {
            newProvince.children = newProvince.children.map(city => {
              // 复制城市对象
              const newCity = { ...city };
              // 移除城市下的区数据
              delete newCity.children;
              return newCity;
            });
          }

          return newProvince;
        });

        this.options = processedList;
      }).catch(err => {
        this.$message.error(err);

      })
    },


    // 获取当前城市位置
    getNowCity() {
      this.$api.getNowCity().then(res => {
        // console.log(res, 'res');
        let cityCode = res.code
        this.$store.commit('SET_CITY', {
          cityCode
        })
        this.selectedValue = cityCode
      }).catch(err => {
        this.$message.error(err);

      })
    },

    // 处理级联选择器的change事件
    handleChange(value, label) {
      // console.log(value, label, '级联选择器选中的值');
      let cityCode = value
      // 可以根据选中的值进行后续操作，比如更新地址信息
      this.$store.commit('SET_CITY', {
        cityCode
      })
    },

    getCascaderLabel(options, valueArr) {
      let currentOptions = [...options];
      const labels = [];
      for (const value of valueArr) {
        const option = currentOptions.find(item => item.value === value);
        if (!option) break;
        labels.push(option.label);
        currentOptions = option.children || [];
      }
      return {
        finalLabel: labels[labels.length - 1] || '', // 最后一级 label
        // fullLabels: labels // 全层级 label
      };
    },



  }
}
</script>

<style scoped>
.header {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 顶部导航栏 */
.top-bar {
  background-color: #f5f5f5;
  padding: 8px 0;
  font-size: 14px;
  color: #666;
}

.top-bar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top-left {
  display: flex;
  align-items: center;
}

.top-left-icon {
  width: 12px;
  height: 12px;
  margin-right: 5px;
}

.top-left-text {
  font-weight: bold;
  font-size: 12px;
  color: #286CED;
}

.top-left-text-text {
  color: #333333;
  margin: 0 11PX;
}

.top-right a {
  margin-left: 20px;
  color: #666;
  text-decoration: none;
  font-size: 12px;
}

.top-right a:hover {
  color: #286CED;
}

/* 主头部 */
.main-header {
  padding: 15px 0;
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: #286CED;
}

.logo img {
  /* width: 137px; */
  height: 69px;
  margin-right: 10px;
}

/* 搜索容器 */
.search-container {
  flex: 1;
  margin: 0 40px;
}

.search-box {
  display: flex;
  margin-bottom: 10px;
}

.search-box input {
  flex: 1;
  padding: 12px 15px;
  border: 2px solid #286CED;
  border-radius: 4px 0 0 4px;
  font-size: 16px;
}

.search-btn {
  padding: 12px 20px;
  background-color: #286CED;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  font-size: 16px;
}

.quick-search,
.login-btn {
  padding: 12px 20px;
  margin-left: 10px;
  /* border: 2px solid #286CED; */
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  border: none;
}

.quick-search {
  background-color: white;
  color: white;
  /* height: 40px; */
  background: #FF9735;
  border-radius: 0px 2px 2px 0px;
}

.login-btn {
  background-color: #286CED;
  color: white;
}

/* 搜索分类 */
.search-categories {
  display: flex;
  gap: 15px;
}

.search-categories a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  padding: 5px 0;
}

.search-categories a.active,
.search-categories a:hover {
  color: #286CED;
  border-bottom: 2px solid #286CED;
}

/* 二维码 */
.qr-code {
  text-align: center;
}

.qr-code img {
  width: 137px;
  height: 80px;
  margin-bottom: 5px;
  cursor: pointer;
}

.qr-code p {
  font-size: 12px;
  color: #666;
  margin: 0;
}

/* 主导航 */
.main-nav {
  border-top: 2px solid #EEE;
  padding-top: 15px;
  display: flex;
  justify-content: space-between;
}

.main-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 40px;
}

.main-nav a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 0;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
}

.main-nav a.active,
.main-nav a:hover {
  color: #286CED;
  border-bottom-color: #286CED;
}

/* 容器 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top-bar {
    display: none;
  }

  .header-top {
    flex-direction: column;
    gap: 20px;
  }

  .search-container {
    margin: 0;
    width: 100%;
  }

  .search-box {
    flex-wrap: wrap;
  }

  .quick-search,
  .login-btn {
    margin-left: 0;
    margin-top: 10px;
    flex: 1;
  }

  .search-categories {
    flex-wrap: wrap;
    gap: 10px;
  }

  .main-nav ul {
    flex-wrap: wrap;
    gap: 20px;
  }
}

/* 自定义Element UI标签页样式 */
::v-deep .el-tabs__header .is-top::after {
  background-color: transparent !important;
}

.top-nav {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logout-btn,
.nav-link {
  color: #333333;
  text-decoration: none;
  font-size: 12px;
  cursor: pointer;
  margin-left: 8px;
}

.logout-btn:hover,
.nav-link:hover {
  color: #286CED;
}

.nav-divider {
  color: #ccc;
}
</style>